import React from "react";
import { Alert } from "@mui/material";
import AppModal from "../common/AppModal";
import CreateOrUpdateUserForm from "../../forms/CreateOrUpdateUserForm";

const UpdateUserModal = ({ open, onClose, user, userInfo, loading, error }) => {
  return (
    <AppModal
      open={open}
      onClose={onClose}
      title={`Edit User: ${user.firstName}`}
      width="md"
    >
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <CreateOrUpdateUserForm
        isEditing={true}
        user={user}
        userInfo={userInfo}
        loading={loading}
        onSuccess={onClose}
      />
    </AppModal>
  );
};
export default UpdateUserModal;
